import React, { useState, useRef, useEffect, useContext } from "react";
import { useHistory, NavLink } from "react-router-dom";
// import NoOrderHistory from "../../components";
import { Grid, Image, Icon, Dropdown, Input, } from 'semantic-ui-react'
import "./DidyouknowScreen.scss";
import renderHTML from 'react-render-html';
import bachansing from "../../assets/home/bachansing.png";
import searchicon from "../../assets/home/searchicon.svg";
import gold from "../../assets/home/gold_arrow.svg";
import onging from "../../assets/home/onging_img.png";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { getDiduknows, setDiduknow } from "../../store/OrderRedux";
import { Config } from "../../common"
import { Loading } from "../../components"
import NoDidyouKnow from "../../components/NoDidyouKnow";

const DidyouknowScreen = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const timer = useRef();
  const [search, setSearch] = useState('')
  const [type, setType] = useState(1)
  const token = useSelector((state) => state.auth.token)
  const diduknows = useSelector((state) => state.order.diduknows)
  const isFetching = useSelector((state) => state.order.isFetching)

  useEffect(() => {
    dispatch(getDiduknows({ token }));
    window.scrollTo(0, 0)
  }, []);

  const handleSearch = (value1 = null, value2 = null) => {
    let searchs = value1 ? value1 : search
    let types = value2 ? value2 : type
    let param = { token }
    if (searchs) {
      param.heading = searchs
    }
    if (types) {
      let category = options.find(x => (x.key == types))
      param.category = category ? category.text : null
    }
    clearInterval(timer.current);
    timer.current = setTimeout(() => {
      dispatch(getDiduknows(param))
    }, 500)
  }

  const options = [
    { key: 1, text: 'Bollywood', value: 1 },
    { key: 2, text: 'Musicians', value: 2 },
    { key: 3, text: 'Cricketers', value: 3 },
    { key: 4, text: 'Sitcom stars', value: 4 },
  ]
  return (
    <div className="container-fluid bg ">
      <div className="didknow_sec">
        <h3>{t('didyouknow.title')} <span> {t('didyouknow.titlesub')}</span></h3>
        <p>{t('didyouknow.para')}</p>
      </div>
      <div className="input_boxs">
        <div className="input_text" Stackable>
          <div className="search_sec">
            <img className="searchicon" src={searchicon} />
            <Input placeholder='Search' value={search} onChange={(e) => {
              setSearch(e.target.value)
              handleSearch(e.target.value, null)
            }} />
          </div>
          <div className="ongoing_sec">
            <img className="onging_img" src={onging} />
            <Dropdown value={type} onChange={(e, { value }) => {
              setType(value)
              handleSearch(null, value)
            }} selection options={options} placeholder='bollywood' />
          </div>

        </div>
      </div>
      {isFetching && (<Loading />)}
        
      
      
      { diduknows.length>0 ?diduknows.map((item, key) => {
        let newItem = Config.GetLanguageSameLine(item, i18n.language)
        return <div key={key} className="celibetry_secs clearall">
          <img className="white_car" src={item.slideImage} />
          <div className="celibrety_text">
            <h5>{newItem.heading}</h5>
            <div className="did_para" onClick={() => { dispatch(setDiduknow(item)); history.push("/didyouknowditels") }}><h6>Read more  <img  src={gold} className = "gold"/> </h6></div>
          </div>
        </div>
      }): <NoDidyouKnow />}
    </div>
  );
};

export default DidyouknowScreen